import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'

import SwbShopDeviceTransVoucherPdf from './ShopDeviceTransVoucherPdf';
//
Vue.regist(SwbShopDeviceTransVoucherPdf);

export function openTrandVouhcerPdfDlg(voucherId, lowCostFlag) {
    //
    Vue.$showDialog({
        title: '业务单据 - 查看',
        width: 1200,
        height: 800,
        okVisible: false,
        showCloseBtn: true,
        okClicked: false,
        cancelText: '关闭',
        template: '<swb-shop-device-trans-voucher-devc-pdf :voucherId="id" :lowCostFlag="lowCostFlag"></swb-shop-device-trans-voucher-devc-pdf>',
        data: {
            id: voucherId,
            lowCostFlag: Utils.isTrue(lowCostFlag) ? lowCostFlag : false
        }
    });
}

import SwbShopDeviceTransVoucherReturnSave from './ShopDeviceTransVoucherReturnSave';

Vue.regist(SwbShopDeviceTransVoucherReturnSave);

// 调拨单验收
export function openShopDeviceTransVoucherReturnSaveDlg(id, callback) {
    let theDlg = Vue.$showDialog({
        title: '设备调拨单 - 退还',
        width: -200,
        height: -200,
        showCloseBtn: true,
        template: '<swb-trans-voucher-devc-return :id="id"  ref="swb_trans_voucher_return"></swb-trans-voucher-devc-return>',
        data: {
            id: id
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_trans_voucher_return.getDlgResult() || {};
            if(result.type === 'info') {
                let resultData = result.data;
                callback(resultData, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

import SwbShopDeviceTransVoucherReceiptSave from './ShopDeviceTransVoucherReceiptSave';
Vue.regist(SwbShopDeviceTransVoucherReceiptSave);
// 调拨单验收
export function openShopDeviceTransVoucherReceiptSaveDlg(params, selectVoucher, callback) {
    let id = params["id"];
    let bizUnitId = params["bizUnitId"];
    let theDlg = Vue.$showDialog({
        title: '调拨单 - 验收',
        width: -50,
        height: -100,
        showCloseBtn: true,
        template: '<swb-trans-devc-receipt-save :id="id" :bizUnitId="bizUnitId" :selectVoucher="selectVoucher"  ref="swb_trans_receipt_save"></swb-trans-devc-receipt-save>',
        data: {
            id: id,
            bizUnitId: bizUnitId,
            selectVoucher: selectVoucher
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_trans_receipt_save.getDlgResult() || {};
            if(!Utils.repeatChecker.isValidFor("saveTransReceiptInfo", 1000)) {   // 防重复点击
                return false;
            }
            if(result.type === 'info') {
                let resultData = result.data;
                callback(resultData, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}




//////////////////
// WEBPACK FOOTER
// ./src/compo/tranVoucherDevc/showDetailDlg.js
// module id = 316
// module chunks = 0